import * as CreDtos from "../CRE.dtos";


export const
    SITE_DATA_REQUEST = "SITE_DATA_REQUEST",
    SITE_DATA_REQUEST_FAILURE = "SITE_DATA_REQUEST_FAILURE",
    SITE_DATA_REQUEST_SUCCESS = "SITE_DATA_REQUEST_SUCCESS"


export function siteDataRequest() {
    return {
        type: SITE_DATA_REQUEST
    };
}

export function siteDataRequestSuccess(siteData: CreDtos.SiteData) {
    return {
        type: SITE_DATA_REQUEST_SUCCESS,
        siteData
    };
}

export function siteDataRequestFailure(error) {
    return {
        type: SITE_DATA_REQUEST_FAILURE,
        error
    };
}



// WEBPACK FOOTER //
// ./src/actions/sitedata.actions.ts